import React, { useState, useEffect } from "react";
import "./style.css";
import Header from "../../../componente/header";
import ModalVenda from "react-modal";
import Paginacao from "../../../componente/paginacao";
import Impressora from "../../../assets/Impressora.png";
import api from "../../../services/api";
import LoadingScreen from "../../../componente/aguarde";
import { podeImprimir, podeInserir } from "../../../componente/permissoes";

const API_URL = "v1/relatorio";
const AUTOCOMPLETE_URL = "v1/relatorio/filtro";

const RelFichaCobrar = () => {
  const [abusca, setabusca] = useState("");
  const [offset, setOffset] = useState(0);
  const [edtcodequipe, setedtcodequipe] = useState(0);
  const [codvendedor1, setcodvendedor1] = useState(0);
  const [edtcidade, setedtcidade] = useState("0");
  const [edtuf, setedtuf] = useState("");
  const [lista, setlista] = useState([]);
  const [listaequipe, setlistaequipe] = useState([]);
  const [listaVendedor1, setlistaVendedor1] = useState([]);
  const [listacidade, setlistacidade] = useState([]);
  const [qtdetotalpag, setqtdetotalpag] = useState(0);
  const [loading, setLoading] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [inputValue1, setInputValue1] = useState("");
  const [inputValue2, setInputValue2] = useState("");
  const [tipoPano1, setTipoPano1] = useState("T");
  const [tipoCliente, setTipoCliente] = useState("T");

  //campos da venda
  const [codcontasreceber, setcodcontasreceber] = useState(0);
  const [edtnome, setedtnome] = useState("");
  const [codvendedor, setcodvendedor] = useState(0);
  const [qtdePeca, setQtdePeca] = useState(0);
  const [qtdeItens, setQtdeItens] = useState(0);
  const [valorPano, setValorPano] = useState(0);
  const [listavendedor, setlistavendedor] = useState([]);
  const [tipo, setTipo] = useState("");
  const [tipoPano, setTipoPano] = useState("");
  const [dtentregapano, setDtEntregaPano] = useState("");
  const [codEquipe, setCodEquipe] = useState(0);
  const [descricaoEquipe, setDescricaoEquipe] = useState("");
  const [nomeVendedor, setNomeVendedor] = useState("");
  const [showformVenda, setshowformVenda] = useState(false);
  const [listaequipe1, setlistaequipe1] = useState([]);

  const { DateTime } = require("luxon");

  const dt = new Date();

  const date1 =
    dt.getFullYear() +
    "-" +
    (dt.getMonth() + 1).toString().padStart(2, "0") +
    "-" +
    dt.getDate().toString().padStart(2, "0");

  const date2 =
    dt.getFullYear() +
    "-" +
    (dt.getMonth() + 1).toString().padStart(2, "0") +
    "-" +
    dt.getDate().toString().padStart(2, "0");

  const [dt1, setdt1] = useState(date1);
  const [dt2, setdt2] = useState(date2);

  const handleEquipeSelecionado = (equip) => {
    setInputValue(equip.descricao);
    setedtcodequipe(equip.codequipe);
    setlistaequipe([]);
  };

  const handleVendedor1Selecionado = (ven) => {
    setInputValue1(ven.nome);
    setcodvendedor1(ven.codfuncionario);
    setlistaVendedor1([]);
  };

  const handleEquipeEdicaoSelecionado = (equip) => {
    setDescricaoEquipe(equip.descricao);
    setCodEquipe(equip.codequipe);
    setlistaequipe1([]);
  };

  const handleVendedorSelecionado = (vend) => {
    setNomeVendedor(vend.nome);
    setcodvendedor(vend.codfuncionario);
    setlistavendedor([]);
  };

  const handleCidadeSelecionado = (cid) => {
    setInputValue2(cid.cidade + " - " + cid.uf);
    setedtcidade(cid.cidade);
    setedtuf(cid.uf);
    setlistacidade([]);
  };

  const handleInputChangeEquipe = async (e) => {
    const value = e.target.value;
    setInputValue(value);

    if (value.length > 2) {
      try {
        const response = await api.get(`${AUTOCOMPLETE_URL}/equipe`, {
          params: { busca: value },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
          },
        });
        setlistaequipe(response.data);
      } catch (error) {
        console.log("ops! ocorreu um erro: " + error);
      }
    } else {
      setlistaequipe([]);
      setedtcodequipe(0);
    }
  };

  const handleInputChangeEquipeEdicao = async (e) => {
    const value = e.target.value;
    setDescricaoEquipe(value);

    if (value.length > 2) {
      try {
        const response = await api.get(`${AUTOCOMPLETE_URL}/equipe`, {
          params: { busca: value },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
          },
        });
        setlistaequipe1(response.data);
      } catch (error) {
        console.log("ops! ocorreu um erro: " + error);
      }
    } else {
      setlistaequipe1([]);
      setCodEquipe(0);
    }
  };

  const handleInputChangeCidade = async (e) => {
    const value = e.target.value;
    setInputValue2(value);

    if (value.length > 2) {
      try {
        const response = await api.get(`${AUTOCOMPLETE_URL}/cidade`, {
          params: { busca: value },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
          },
        });
        setlistacidade(response.data);
      } catch (error) {
        console.log("ops! ocorreu um erro: " + error);
      }
    } else {
      setlistacidade([]);
      setedtcidade("0");
      setedtuf("");
    }
  };

  const handleInputChangeVendedor1 = async (e) => {
    const value = e.target.value;
    setInputValue1(value);

    if (value.length > 2) {
      setLoading(true);
      try {
        const response = await api.get(`${AUTOCOMPLETE_URL}/vendedor1`, {
          params: { busca: value },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
          },
        });
        setlistaVendedor1(response.data);
      } catch (error) {
        console.log("ops! ocorreu um erro: " + error);
      } finally {
        setLoading(false);
      }
    } else {
      setlistaVendedor1([]);
      setcodvendedor1(0);
    }
  };

  const handleInputChangeVendedor = async (e) => {
    const value = e.target.value;
    setNomeVendedor(value);

    if (value.length > 0) {
      try {
        const response = await api.get(`${AUTOCOMPLETE_URL}/vendedor`, {
          params: { busca: value, codequipe: codEquipe },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
          },
        });
        setlistavendedor(response.data);
      } catch (error) {
        console.log("ops! ocorreu um erro: " + error);
      }
    } else {
      setlistavendedor([]);
      setcodvendedor("0");
    }
  };

  const imprimir = async () => {
    setLoading(true);

    try {
      const response = await api.get(`v1/impressoes/relfichacobrar`, {
        responseType: "arraybuffer",
        params: {
          busca: abusca,
          codequipe: edtcodequipe,
          codvendedor: codvendedor1,
          cidade: edtcidade,
          uf: edtuf,
          tipopano: tipoPano1,
          tipocliente: tipoCliente,
          usuario: localStorage.getItem("tempUsuario"),
          dt1,
          dt2,
          codusuario: localStorage.getItem("tempCodUsuario"),
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      });

      const blob = new Blob([response.data], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.target = "_blank";
      link.click();
    } catch (error) {
      console.log("ops! ocorreu um erro: " + error);
    } finally {
      setLoading(false);
    }
  };

  const fetchListar = async () => {
    setLoading(true);

    try {
      const response = await api.get(`${API_URL}/fichacobrar`, {
        params: {
          busca: abusca,
          offset,
          codequipe: edtcodequipe,
          codvendedor: codvendedor1,
          cidade: edtcidade,
          uf: edtuf,
          tipopano: tipoPano1,
          tipocliente: tipoCliente,
          dt1,
          dt2,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      });

      setlista(response.data);
    } catch (error) {
      console.log("ops! ocorreu um erro: " + error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchListar();
  }, [
    abusca,
    offset,
    edtcidade,
    edtcodequipe,
    tipoPano1,
    tipoCliente,
    codvendedor1,
    dt1,
    dt2,
  ]);

  const fetchListarPaginas = async () => {
    try {
      const response = await api.get(`${API_URL}/fichacobrar/pagtotal3`, {
        params: {
          busca: abusca,
          codequipe: edtcodequipe,
          codvendedor: codvendedor1,
          tipopano: tipoPano1,
          tipocliente: tipoCliente,
          cidade: edtcidade,
          uf: edtuf,
          dt1,
          dt2,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      });

      setqtdetotalpag(response.data.paginatotal);
    } catch (error) {
      console.log("ops! ocorreu um erro: " + error);
    }
  };

  useEffect(() => {
    fetchListarPaginas();
  }, [lista]);

  function FormataData(props) {
    return props
      ? DateTime.fromISO(props).plus({ hours: 3 }).toFormat("dd/MM/yyyy")
      : null;
  }

  function AtualizarVenda() {
    if (codEquipe === 0) {
      alert("Informe a Equipe");
    } else if (codvendedor === 0) {
      alert("Informe o vendedor");
    } else {
      api
        .post(
          "/v1/relatorio/fichacobrar/atualizarvenda",
          {
            dtentregapano,
            codequipe: codEquipe,
            tipo,
            codvendedor,
            tipopano: tipoPano,
            qtdepeca: qtdePeca,
            qtdeitens: qtdeItens,
            valorpano: valorPano,
            codcontasreceber,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
            },
          }
        )
        .then(() => {
          setshowformVenda(false);
        })
        .catch(function (err) {
          console.log("ops! ocorreu um erro: " + err);
        });

      fetchListar();
    }
  }

  function closeModalVenda() {
    setshowformVenda(false);
  }

  async function openModalInformarVenda(item) {
    setLoading(true);

    try {
      const response = await api.get("v1/relatorio/fichacobrar/vendaum", {
        params: {
          codcontasreceber: item.codcontasreceber,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      });
      setshowformVenda(true);

      setcodcontasreceber(item.codcontasreceber);

      setDescricaoEquipe(response.data.equipe);
      setCodEquipe(response.data.codequipe);
      setNomeVendedor(response.data.funcionario);
      setcodvendedor(response.data.codvendedor);
      setTipo(response.data.tipo);

      const dt1 = DateTime.fromISO(response.data.dtentragapano)
        .plus({ hours: 3 })
        .toFormat("yyyy-MM-dd");

      setDtEntregaPano(dt1);

      setTipoPano(response.data.tipopano);
      setQtdePeca(response.data.qtdepeca);
      setQtdeItens(response.data.qtdeitens);
      setValorPano(response.data.valorpano);

      setedtnome(response.data.nome);
    } catch (error) {
      console.log("ops! ocorreu um erro: " + error);
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      <Header />
      <div className="container-fluid">
        <ModalVenda
          isOpen={showformVenda}
          onRequestClose={closeModalVenda}
          overlayClassName="modal-overlay"
          className="modal-content modal-xl"
          contentLabel="Modal 1"
        >
          <div className="container-fluid h-100">
            <div className="row">
              <h2>Edição da Venda de: {edtnome}</h2>
            </div>
            <div className="row">
              <hr />
            </div>

            <div className="row">
              <form>
                <div className="row">
                  <div className="col-xl-3 col-lg-5 col-md-5 col-sm-5">
                    <label htmlFor="equipe" className="form-label">
                      Equipe
                    </label>
                    <input
                      id="equipe"
                      type="text"
                      className="form-control"
                      value={descricaoEquipe}
                      onChange={handleInputChangeEquipeEdicao}
                    />
                    <ul className="autocomplete-list">
                      {listaequipe1.map((equipe) => (
                        <li
                          key={equipe.codequipe}
                          onClick={() => handleEquipeEdicaoSelecionado(equipe)}
                        >
                          {equipe.descricao}
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div className="col-sm-4">
                    <div>
                      <label className="form-label">Tipo</label>
                      <br />
                      <div className="form-check form-check-inline">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="tipo"
                          value="R"
                          onChange={(e) => setTipo(e.target.value)}
                          checked={tipo === "R"}
                        />
                        <label className="form-check-label">Reposição</label>
                      </div>

                      <div className="form-check form-check-inline">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="tipo"
                          value="N"
                          onChange={(e) => setTipo(e.target.value)}
                          checked={tipo === "N"}
                        />
                        <label className="form-check-label">Cliente Novo</label>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-xl-3 col-lg-5 col-md-5 col-sm-5">
                    <label htmlFor="vendedor" className="form-label">
                      Vendedor
                    </label>
                    <input
                      id="vendedor"
                      type="text"
                      className="form-control"
                      value={nomeVendedor}
                      onChange={handleInputChangeVendedor}
                    />
                    <ul className="autocomplete-list">
                      {listavendedor.map((vend) => (
                        <li
                          key={vend.codfuncionario}
                          onClick={() => handleVendedorSelecionado(vend)}
                        >
                          {vend.nome}
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div className="col-sm-3">
                    <label htmlFor="dtentregapano" className="form-label">
                      Dt. Entrega do Pano
                    </label>
                    <input
                      type="date"
                      id="dtentregapano"
                      className="form-control"
                      placeholder="dtentregapano"
                      value={dtentregapano}
                      onChange={(e) => setDtEntregaPano(e.target.value)}
                    />
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm-3">
                    <label className="form-label">Tipo de Pano</label>
                    <br />
                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="tipopano"
                        value="S"
                        onChange={(e) => setTipoPano(e.target.value)}
                        checked={tipoPano === "S"}
                      />
                      <label className="form-check-label">Simples</label>
                    </div>

                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="tipopano"
                        value="E"
                        onChange={(e) => setTipoPano(e.target.value)}
                        checked={tipoPano === "E"}
                      />
                      <label className="form-check-label">Especial</label>
                    </div>

                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="tipopano"
                        value="O"
                        onChange={(e) => setTipoPano(e.target.value)}
                        checked={tipoPano === "O"}
                      />
                      <label className="form-check-label">Ouro</label>
                    </div>

                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="tipopano"
                        value="P"
                        onChange={(e) => setTipoPano(e.target.value)}
                        checked={tipoPano === "P"}
                      />
                      <label className="form-check-label">Prata</label>
                    </div>

                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="tipopano"
                        value="B"
                        onChange={(e) => setTipoPano(e.target.value)}
                        checked={tipoPano === "B"}
                      />
                      <label className="form-check-label">Bronze</label>
                    </div>

                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="tipopano"
                        value="M"
                        onChange={(e) => setTipoPano(e.target.value)}
                        checked={tipoPano === "M"}
                      />
                      <label className="form-check-label">Maleta</label>
                    </div>

                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="tipopano"
                        value="L"
                        onChange={(e) => setTipoPano(e.target.value)}
                        checked={tipoPano === "L"}
                      />
                      <label className="form-check-label">Platinado</label>
                    </div>
                  </div>

                  <div className="col-sm-3">
                    <label htmlFor="qtdepeca" className="form-label">
                      Qtde Peças
                    </label>
                    <input
                      type="number"
                      id="qtdepeca"
                      className="form-control"
                      value={qtdePeca}
                      onChange={(e) => setQtdePeca(e.target.valueAsNumber)}
                    />
                  </div>

                  <div className="col-sm-3">
                    <label htmlFor="qtdeitens" className="form-label">
                      Qtde Itens
                    </label>
                    <input
                      type="number"
                      id="qtdeitens"
                      className="form-control"
                      value={qtdeItens}
                      onChange={(e) => setQtdeItens(e.target.valueAsNumber)}
                    />
                  </div>

                  <div className="col-sm-3">
                    <label htmlFor="valorpano" className="form-label">
                      Valor do Pano
                    </label>
                    <input
                      type="number"
                      id="valorpano"
                      className="form-control"
                      value={valorPano}
                      onChange={(e) => setValorPano(e.target.valueAsNumber)}
                    />
                  </div>
                </div>
              </form>
            </div>

            <div className="row">
              <div className="col-12 mt-3 d-flex justify-content-end">
                <button
                  className="btn btn-danger ms-4"
                  onClick={closeModalVenda}
                >
                  Fechar
                </button>
                <button
                  className="btn btn-success ms-4"
                  onClick={AtualizarVenda}
                >
                  Salvar
                </button>
              </div>
            </div>
          </div>
        </ModalVenda>

        <div className="row">
          <h1 className="ms-4">Relatório de Ficha Para Cobrar</h1>
          <p className="ms-4">
            Rotina para listar todas as fichas para cobrar, com a opção de
            filtrar por cidade, equipe e data de lançamento.
          </p>
          <hr />
        </div>

        <div className="row">
          <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12">
            <label className="form-label" htmlFor="busca">
              Busque aqui
            </label>
            <input
              type="text"
              placeholder="Buscar por: Código, nome ou cpf"
              name="busca"
              id="busca"
              className="form-control me-3"
              value={abusca}
              onChange={(e) => {
                setabusca(e.target.value);
                setOffset(0);
              }}
            />
          </div>

          <div className="col-xl-2 col-lg-3 col-md-3 col-sm-12">
            <label htmlFor="periodo" className="form-label">
              de...
            </label>
            <br />
            <input
              type="date"
              id="periodo"
              className="form-control"
              placeholder="Data Inicio"
              value={dt1}
              onChange={(e) => setdt1(e.target.value)}
            />
          </div>

          <div className="col-xl-2 col-lg-3 col-md-3 col-sm-12">
            <label htmlFor="periodo" className="form-label">
              Para...
            </label>
            <br />
            <input
              type="date"
              id="periodo2"
              className="form-control"
              placeholder="dtnascimento"
              value={dt2}
              onChange={(e) => setdt2(e.target.value)}
            />
          </div>

          <div className="col-xl-2 col-lg-3 col-md-6 col-sm-12">
            <label className="form-label">Pano</label>
            <br />
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="tipopano"
                value="T"
                onChange={(e) => setTipoPano1(e.target.value)}
                checked={tipoPano1 === "T"}
              />
              <label className="form-check-label">Todos</label>
            </div>
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="tipopano"
                value="S"
                onChange={(e) => setTipoPano1(e.target.value)}
                checked={tipoPano1 === "S"}
              />
              <label className="form-check-label">Simples</label>
            </div>

            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="tipopano"
                value="E"
                onChange={(e) => setTipoPano1(e.target.value)}
                checked={tipoPano1 === "E"}
              />
              <label className="form-check-label">Especial</label>
            </div>

            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="tipopano"
                value="O"
                onChange={(e) => setTipoPano1(e.target.value)}
                checked={tipoPano1 === "O"}
              />
              <label className="form-check-label">Ouro</label>
            </div>

            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="tipopano"
                value="P"
                onChange={(e) => setTipoPano1(e.target.value)}
                checked={tipoPano1 === "P"}
              />
              <label className="form-check-label">Prata</label>
            </div>

            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="tipopano"
                value="B"
                onChange={(e) => setTipoPano1(e.target.value)}
                checked={tipoPano1 === "B"}
              />
              <label className="form-check-label">Bronze</label>
            </div>

            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="tipopano"
                value="M"
                onChange={(e) => setTipoPano1(e.target.value)}
                checked={tipoPano1 === "M"}
              />
              <label className="form-check-label">Maleta</label>
            </div>

            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="tipopano"
                value="L"
                onChange={(e) => setTipoPano1(e.target.value)}
                checked={tipoPano1 === "L"}
              />
              <label className="form-check-label">Platinado</label>
            </div>
          </div>

          <div className="col-xl-1 col-lg-3 col-md-6 col-sm-12">
            <label className="form-label">Tipo</label>
            <br />
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="tipocliente"
                value="T"
                onChange={(e) => setTipoCliente(e.target.value)}
                checked={tipoCliente === "T"}
              />
              <label className="form-check-label">Todos</label>
            </div>
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="tipocliente"
                value="N"
                onChange={(e) => setTipoCliente(e.target.value)}
                checked={tipoCliente === "N"}
              />
              <label className="form-check-label">Cliente Novo</label>
            </div>

            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="tipocliente"
                value="R"
                onChange={(e) => setTipoCliente(e.target.value)}
                checked={tipoCliente === "R"}
              />
              <label className="form-check-label">Reposição</label>
            </div>
          </div>

          <div className="col-xl-1 col-lg-6 col-md-12 col-sm-12 d-flex justify-content-center">
            <button className="btn" onClick={imprimir} disabled={!podeImprimir("/relatorio/fichacobrar")}>
              <img src={Impressora} alt="Imprimir" />
              <label>Imprimir</label>
            </button>
            {loading && <LoadingScreen />}
          </div>
        </div>

        <div className="row">
          <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
            <label htmlFor="equipe" className="form-label">
              Equipe
            </label>
            <input
              type="text"
              className="form-control"
              value={inputValue}
              onChange={handleInputChangeEquipe}
            />
            <ul className="autocomplete-list">
              {listaequipe.map((equipe) => (
                <li
                  key={equipe.codequipe}
                  onClick={() => handleEquipeSelecionado(equipe)}
                >
                  {equipe.descricao}
                </li>
              ))}
            </ul>
          </div>

          <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
            <label htmlFor="equipe" className="form-label">
              Vendedor
            </label>
            <input
              type="text"
              className="form-control"
              value={inputValue1}
              onChange={handleInputChangeVendedor1}
            />
            <ul className="autocomplete-list">
              {listaVendedor1.map((ven) => (
                <li
                  key={ven.codfuncionario}
                  onClick={() => handleVendedor1Selecionado(ven)}
                >
                  {ven.nome}
                </li>
              ))}
            </ul>
          </div>

          <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
            <label htmlFor="cidade" className="form-label">
              Cidade
            </label>
            <input
              type="text"
              className="form-control"
              value={inputValue2}
              onChange={handleInputChangeCidade}
            />
            <ul className="autocomplete-list">
              {listacidade.map((cid) => (
                <li
                  key={cid.cidade}
                  onClick={() => handleCidadeSelecionado(cid)}
                >
                  {cid.cidade} - {cid.uf}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="row mt-3">
          <hr />
        </div>

        <div className="row tabela">
          <table className="col-sm-12 table table-hover">
            <thead>
              <tr>
                <th>Código</th>
                <th>Entrega</th>
                <th>Vencimento</th>
                <th>Cliente</th>
                <th>Cidade</th>
                <th>Equipe</th>
                <th>Vendedor</th>
                <th>Tipo</th>
                <th>Pano</th>
                <th>Qtde Peças</th>
                <th>Qtde Itens</th>
                <th>Valor do Pano</th>
                <th>Ação</th>
              </tr>
            </thead>
            <tbody>
              {lista.map((item) => (
                <tr key={item.codcontasreceber}>
                  <th>{item.codcontasreceber}</th>
                  <th>{FormataData(item.dtentragapano)}</th>
                  <th>{FormataData(item.dtvencimento)}</th>
                  <th>{item.cliente}</th>
                  <th>
                    {item.cidade} - {item.uf}
                  </th>
                  <th>{item.equipe}</th>
                  <th>{item.vendedor}</th>
                  <th>{item.tipo}</th>
                  <th>{item.tipopano}</th>
                  <th>{item.qtdepeca}</th>
                  <th>{item.qtdeitens}</th>
                  <th>
                    {parseFloat(item.valorpano).toLocaleString("pt-BR", {
                      style: "currency",
                      currency: "BRL",
                    })}
                  </th>
                  <th>
                    <div className="d-flex justify-content-center">
                      <button
                        className="btn fa-regular fa-pen-to-square"
                        onClick={() => openModalInformarVenda(item)}
                        disabled={!podeInserir("/relatorio/fichacobrar")}
                      ></button>
                    </div>
                  </th>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr>
                <td colSpan="3">Quantidade de linhas: {lista.length}</td>
                <td colSpan="1">Quantidade total de linhas: {qtdetotalpag}</td>
                <td colSpan="5">
                  Total:{" "}
                  {lista
                    .reduce(
                      (total, item) => total + parseFloat(item.valorpano),
                      0
                    )
                    .toLocaleString("pt-BR", {
                      style: "currency",
                      currency: "BRL",
                    })}
                </td>
              </tr>
            </tfoot>
          </table>
        </div>

        <div className="row mt-3">
          <hr />
        </div>

        <div className="row d-flex justify-content-center">
          <Paginacao
            limit={20}
            total={qtdetotalpag}
            offset={offset}
            setOffset={setOffset}
          />
        </div>
      </div>
    </>
  );
};

export default RelFichaCobrar;
